import { render } from "./ReqManageMain.vue?vue&type=template&id=270b64d0&scoped=true"
import script from "./ReqManageMain.vue?vue&type=script&lang=js"
export * from "./ReqManageMain.vue?vue&type=script&lang=js"

import "./ReqManageMain.vue?vue&type=style&index=0&id=270b64d0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270b64d0"]])

export default __exports__